var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30559 0.74585C1.87704 0.74585 0.732899 1.90292 0.732899 3.33147L0.719971 24.0164C0.719971 25.445 1.86411 26.6021 3.29266 26.6021H18.8193C20.2479 26.6021 21.4049 25.445 21.4049 24.0164V8.50271L13.6481 0.74585H3.30559ZM12.3553 9.79552V2.68507L19.4657 9.79552H12.3553Z",
    fill: "#134974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFill);
export default __webpack_public_path__ + "static/media/file-fill.c06d7fabdbef2634236c512912abc227.svg";
export { ForwardRef as ReactComponent };